// src/pages/ErrorPlanManagement/index.tsx
// Trang riêng "Quản lý kế hoạch lỗi" — tách ra từ tab cùng tên trong /issuance-plans (mục 10.2,
// READE.md). Nội dung chính vẫn dùng lại nguyên ErrorPlanManagementTab, chỉ đổi chỗ chứa từ tab
// sang page riêng với BreadCrumb của chính nó; component đó tự fetch dữ liệu lỗi, chỉ cần truyền
// danh sách kế hoạch phát hành (dùng cho dropdown lọc theo kỳ + tra mã kỳ).
import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { toast } from "react-toastify";

import BreadCrumb from "Components/Common/BreadCrumb";
import ErrorPlanManagementTab from "pages/IssuancePlan/components/ErrorPlanManagementTab";
import { getIssuancePlans } from "helpers/fakebackend_helper";
import { IssuancePlan } from "pages/IssuancePlan/types";
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('error_plan_management');

// Không còn bị giới hạn bởi phân trang 20/trang của màn danh sách kế hoạch (trước đây dùng chung
// state `plans` với tab "list") — lấy 1 lượng đủ lớn để dropdown lọc theo kỳ có đầy đủ lựa chọn.
const PLANS_PAGE_SIZE = 100;

const ErrorPlanManagementPage: React.FC = () => {
  const [plans, setPlans] = useState<IssuancePlan[]>([]);
  const [loadingPlans, setLoadingPlans] = useState(false);

  const loadPlans = useCallback(async () => {
    setLoadingPlans(true);
    try {
      const response = await getIssuancePlans({ pageIndex: 1, pageSize: PLANS_PAGE_SIZE });
      const payload = (response as any)?.data || response;
      setPlans(payload.items || payload.data || payload || []);
    } catch (error: any) {
      toast.error(error?.message || st('khong_the_tai_danh_sach_ke_message'));
    } finally {
      setLoadingPlans(false);
    }
  }, []);

  useEffect(() => {
    document.title = st('quan_ly_ke_hoach_loi_text');
    loadPlans();
  }, [loadPlans]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={st('quan_ly_ke_hoach_loi_text')} pageTitle={st('quan_ly_phat_hanh_text')} />

          {loadingPlans && plans.length === 0 ? (
            <div className="text-center py-5">
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </div>
          ) : (
            <ErrorPlanManagementTab plans={plans} />
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ErrorPlanManagementPage;
